import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';

/** 忘记密码：邮箱验证码 + 新密码。邮箱没注册过时页面也显示「已发送」，不暴露谁注册过。 */
export const ForgotPasswordForm: React.FC<{ onDone: () => void }> = ({ onDone }) => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [cooldown, setCooldown] = useState(0);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  const fail = (e: any) => setMsg({ ok: false, text: e?.response?.data?.message || '操作失败，请重试' });

  const sendCode = async () => {
    setBusy(true);
    setMsg(null);
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setCooldown(60);
      setMsg({ ok: true, text: '如果这个邮箱注册过，验证码已发送，请查收邮件（10 分钟内有效）' });
    } catch (e) {
      fail(e);
    } finally {
      setBusy(false);
    }
  };

  const reset = async (ev: React.FormEvent) => {
    ev.preventDefault();
    setBusy(true);
    setMsg(null);
    try {
      await api.post('/auth/reset-password', { email: email.trim(), code: code.trim(), password });
      setMsg({ ok: true, text: '密码已重置，请用新密码登录' });
      setTimeout(onDone, 1500);
    } catch (e) {
      fail(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={reset} className="space-y-4">
      <Input label="注册邮箱" type="email" placeholder="请输入注册时的邮箱" value={email} onChange={e => setEmail(e.target.value)} />
      <div className="flex items-end gap-2">
        <div className="flex-1">
          <Input label="验证码" inputMode="numeric" maxLength={6} placeholder="6位数字" value={code} onChange={e => setCode(e.target.value)} />
        </div>
        <Button type="button" variant="secondary" disabled={busy || cooldown > 0 || !email.trim()} onClick={sendCode} className="shrink-0 mb-px">
          {cooldown > 0 ? `${cooldown} 秒后重发` : '发送验证码'}
        </Button>
      </div>
      <Input label="新密码" type="password" placeholder="至少6位密码" value={password} onChange={e => setPassword(e.target.value)} />
      {msg && (
        <div className={`p-3 rounded-lg border text-sm ${msg.ok ? 'bg-green-50 border-green-200 text-green-700' : 'bg-red-50 border-red-200 text-red-600'}`}>{msg.text}</div>
      )}
      <Button type="submit" loading={busy} disabled={code.trim().length !== 6 || password.length < 6 || !email.trim()} className="w-full" variant="primary">
        重置密码
      </Button>
      <button type="button" onClick={onDone} className="w-full text-sm text-gray-500 hover:text-gray-800">返回登录</button>
    </form>
  );
};
